<template>
  <div class="pb-20 pt-6 lg:pb-24">
    <h3
      v-if="title"
      class="mb-6 max-w-3xl text-2xl leading-[1.2] tracking-[-1px] text-white lg:mb-14 lg:text-4xl">
      {{ title }}
    </h3>
    <NuxtLink
      v-for="(job, index) in jobsSortedByPriority"
      :key="index"
      class="group flex flex-col items-start justify-between border-b border-gray-400 pb-6 pt-6 transition lg:flex-row lg:items-center lg:px-4 lg:pt-8 lg:hover:bg-gray-500"
      :href="resolveJobUri(job.uri)">
      <div class="">
        <div class="text-xl text-gray-100 transition lg:text-2xl lg:text-gray-200 lg:group-hover:text-white">
          {{ job.title }}
        </div>
        <div class="">
          <span
            v-for="(location, i) in job.locations"
            :key="location.key"
            class="mt-1 text-gray-250"
            >{{ i > 0 ? ' • ' : '' }}{{ location.label }}
          </span>
        </div>
      </div>

      <div class="mt-4 flex flex-wrap items-start gap-2 lg:ml-auto lg:mt-0">
        <div
          v-if="job.division"
          class="rounded-full border border-gray-200 bg-gray-200 px-4 py-1 text-sm">
          {{ job.division }}
        </div>
        <div
          v-if="job.employmentType"
          class="rounded-full border border-gray-200 px-4 py-1 text-sm text-gray-200">
          {{ job.employmentType }}
        </div>
        <template v-if="job.workTypes">
          <div
            v-for="workType in job.workTypes"
            :key="workType"
            class="rounded-full border border-gray-200 px-4 py-1 text-sm text-gray-200">
            {{ workType }}
          </div>
        </template>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  import type { JobType } from '~/models/jobs'

  type TableProps = {
    title?: string
    jobs: JobType[]
  }

  const props = withDefaults(defineProps<TableProps>(), {
    title: ''
  })

  const { isInternalJobReferrals } = useInternalJobreferrals()

  const jobsSortedByPriority = computed(() => {
    const jobs = [...props.jobs]

    jobs.forEach(job => {
      if (!job.priority) {
        job.priority = 3
      }
    })

    return jobs.sort((a, b) => a.priority - b.priority)
  })

  function resolveJobUri(jobUri: string) {
    return isInternalJobReferrals.value ? jobUri.replace('/jobs/', '/internal-job-referrals/') : jobUri
  }
</script>
